export const contactsData = {
    email: 'iankinuthia00@gmail.com',
    phone: '+254741466076',
    address: 'Nairobi, Kenya',
    website: 'https://iankportfolio.netlify.app/'
}